import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'SHIVKMS';
const SITE_URL = 'https://www.shivkms.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function SEO({
  title,
  description,
  keywords,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  schema,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Intelligent Software Solutions Since 1998`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      {/* Primary */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Geo / Local Business */}
      <meta name="geo.region" content="IN-DL" />
      <meta name="geo.placename" content="Delhi" />
      <meta name="author" content={SITE_NAME} />
      <meta name="robots" content="index, follow" />

      {/* Structured data */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}

export const ORG_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'SHIVKMS',
  alternateName: 'SHIVKMS',
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  foundingDate: '1998',
  description: 'SHIVKMS has been a leader in providing customized software solutions for over 27 years — RTA software, school management, hotel management, e-commerce, CRM/ERP and more.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '1000/67, Trinagar',
    addressLocality: 'Delhi',
    postalCode: '110035',
    addressCountry: 'IN',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+91-9212552928',
    contactType: 'customer service',
    email: 'contact@shivkms.com',
    areaServed: 'IN',
    availableLanguage: ['English', 'Hindi'],
  },
  sameAs: [],
};
